import React, { useEffect, useState } from "react";
import Select from "react-select";

export type Option = {
  value: string;
  label: string;
  name?: string;
};

export interface SelectProps {
  options: Option[];
  name?: string;
  defaultValue?: string | any;
  className?: string;
  styles?: any;
  disabled?: boolean;
  onChange?: (option: Option | null) => void; // Added onChange to props
  onFocus?: (
    event: React.FocusEvent<
      HTMLDivElement | HTMLInputElement | HTMLSelectElement
    >,
  ) => void;
  showValue?: boolean;
  showDefaultOption?: boolean;
}

const CommonSelect2: React.FC<SelectProps> = ({
  options,
  name,
  defaultValue = "",
  className = "",
  disabled,
  onChange,
  onFocus,
  showValue = false,
  showDefaultOption = true,
}) => {
  const [selectedOption, setSelectedOption] = useState<Option | undefined>(
    undefined,
  );

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    const matchedOption =
      options?.find((opt) => opt.value == selectedValue) || null;

    setSelectedOption(matchedOption || undefined);
    if (onChange) {
      onChange(matchedOption);
    }
  };

  useEffect(() => {
    const initialOption = options.find((opt) => opt.value == defaultValue);
    setSelectedOption(initialOption);
    // setSelectedOption(defaultValue || undefined);
  }, [defaultValue, options]);

  return (
    <>
      <Select
        classNamePrefix="react-select"
        className={className}
        name={name}
        value={selectedOption || null}
        options={[
          ...(showDefaultOption
            ? [{ value: "", label: "--Select--" }]
            : [{ value: "all", label: "All" }]),
          ...options,
        ]}
        onFocus={onFocus}
        onChange={(option: Option) => {
          const selected = option as Option | null;

          setSelectedOption(selected || undefined);

          if (onChange) {
            onChange(selected);
          }
        }}
        isDisabled={disabled}
        menuPlacement="bottom"
        formatOptionLabel={(option: Option) => (
          <div className="py-0 my-0">
            {showValue ? `${option.value} - ${option.label}` : option.label}
          </div>
        )}
      />
      {/* <select
        className={`${className} form-select form-select-sm dropdown-wrapper ${disabled ? "cursor-not-allowed" : ""} `}
        name={name}
        // defaultValue={defaultValue}
        value={selectedOption?.value || ""}
        onFocus={onFocus}
        onChange={handleChange}
        disabled={disabled}
      >
        {showDefaultOption ? (
          <option value="">--Select--</option>
        ) : (
          <option value="all">All</option>
        )}
        {options?.map((option) => {
          return (
            <option key={option?.value} value={option?.value}>
              {showValue && (
                <>
                  {option.value} - {option?.label}
                </>
              )}
              {!showValue && option.label}
            </option>
          );
        })}
      </select> */}
    </>
  );
};

export default CommonSelect2;
